import { RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';
import { JobWrapper } from '@shared/components/job-wrapper/job-wrapper';

@Component({
  selector: 'ta-cost-wrapper',
  template: `
    <ta-job-wrapper dialogCssClass="h-full lg:h-177 w-full lg:w-[40rem]" [visible]="true">
      <router-outlet />
    </ta-job-wrapper>
  `,
  imports: [RouterOutlet, JobWrapper]
})
export class CostWrapper {}
